import { Component } from '@opten/compiler/metadata/component';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { GallerySliderComponent } from '../gallery-slider/gallery-slider';
import MicroModal from 'micromodal';
import { getWindowScrollTop } from '@opten/dom/get-window-scroll-top';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

@Component({ className: 'js-modal', observe: true })
export class ModalComponent {
	private overlay: HTMLElement;
	sliderInstance: GallerySliderComponent;

	constructor(private element: HTMLElement) {
		const modal = document.querySelector(this.element.getAttribute('href'));
		if (modal) {
			this.overlay = modal.querySelector('.js-modal-overlay');
			this.element.addEventListener('click', $event => {
				$event.preventDefault();
				this.open();
			});

			modal.addEventListener(
				'close',
				e => {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
					MicroModal.close(modal.id);
				}
			);
		}
	}

	private open() {
		if (this.element.getAttribute('href')) {
			const scrollTopPosition = getWindowScrollTop();
			MicroModal.show(this.element.getAttribute('href').replace('#', ''), {
				allowTouchMove: el => el.tagName === 'INPUT',
				onShow: modal => {
					const slider = modal.querySelector('.js-gallery-slider');
					if (slider) {
						const index = this.element.parentElement.getAttribute('data-index');
						this.sliderInstance = new GallerySliderComponent(slider as HTMLElement, true, +index);
					}
					disableBodyScroll(this.overlay);
					addClass(document.body, 'modal--is-open');
				},
				onClose: modal => {
					if (this.sliderInstance) {
						this.sliderInstance.destroy();
					}
					enableBodyScroll(this.overlay);
					window.scrollTo(0, scrollTopPosition);
					setTimeout(() => removeClass(document.body, 'modal--is-open'), 350);
				}
			});
		}
	}
}
